
import Vue, { PropType } from 'vue';
import BaseToggle from '@/components/base/BaseToggle.vue';

export interface RolloutRowData {
	kind: 'company' | 'team' | 'person'
	id: string
	// a person's email
	name: string
	// a team's company and size; a person's teams and companies
	detail: string
	// turned on itself
	on: boolean
	// a team whose company is turned on
	viaCompany: boolean
}

const ICONS: Record<RolloutRowData['kind'], string> = {
	company: 'mdi-domain',
	team: 'mdi-account-multiple-outline',
	person: 'mdi-account-outline',
};

// One company, team or person on the Boards v2 Rollout page, with its switch
export default Vue.extend({
	name: 'RolloutRow',
	props: {
		row: { type: Object as PropType<RolloutRowData>, required: true },
		saving: { type: Boolean, default: false },
	},
	computed: {
		icon (): string {
			return ICONS[this.row.kind];
		},
	},
	components: {
		BaseToggle,
	},
});
